import script from "./Lists.vue?vue&type=script&setup=true&lang=js"
export * from "./Lists.vue?vue&type=script&setup=true&lang=js"

import "./Lists.vue?vue&type=style&index=0&id=aa83a082&lang=css"

const __exports__ = script;

export default __exports__